module.exports = __webpack_public_path__ + "bff62724456dc6d9a4e7cc4604973c90.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-8.png
// module id = 2098
// module chunks = 0